/* eslint-disable import/max-dependencies */
import type { AnyAction, Store } from "redux";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import {
  initNotificationsState,
  notificationsReducer as notifications,
} from "@fas/ui-framework";
import Immutable from "immutable";
import createSagaMiddleware from "redux-saga";
import mainSaga from "./saga";

export type State = {
  notifications: ReturnType<typeof initNotificationsState>;
};

export type Actions = AnyAction;
export type CabinetStore = Store<State>;

export const mapCabinetToState = () => ({
  notifications: initNotificationsState(),
});

const reducers = combineReducers({
  notifications,
});

const sagaMiddleware = createSagaMiddleware();

export default (): CabinetStore => {
  const composeEnhancers =
    // eslint-disable-next-line no-underscore-dangle
    typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      serialize: {
        immutable: Immutable,
      },
    })
      : compose;
  const store = createStore(
    reducers,
    mapCabinetToState(),
    composeEnhancers(applyMiddleware(sagaMiddleware))
  );
  sagaMiddleware.run(mainSaga);
  return store;
};
